import React from 'react';
import Advisor from './advisor';
import { useConfig } from './default-config';
import familyCar from '../../resources/familie_bil.png';

const Results = ({ score, onClick }: { score: number; onClick: () => void }) => {
    const { texts, results, resultLimits } = useConfig();
    const limits = resultLimits.split('|').map(value => parseInt(value, 10));

    const getResultsFromScore = (score: number) => {
        if (score < limits[0]) return results.resultAnsvar;
        if (score < limits[1]) return results.resultDelkasko;
        if (score < limits[2]) return results.resultKasko;
        if (score < limits[3]) return results.resultKaskoMedLeiebil;
        return results.resultBilPluss;
    };

    const resultTexts = getResultsFromScore(score).split('|');

    return (
        <div className="result">
            <div className="result-header">{texts.result}</div>
            <h2 className="h2 result-insurance">
                {resultTexts[0]} {texts.carInsurance}
            </h2>
            <div className="result-text">{resultTexts[1]}</div>
            <Advisor description={resultTexts[2]} />
            <button type="button" className="btn btn-flat btn-result" onClick={onClick}>
                {texts.tryAgain}
            </button>
            <img className="result-image" alt="bil med lykkelig familie" src={familyCar} />
        </div>
    );
};

export default Results;
